







































































































































































import Vue from 'vue'

export default Vue.extend({
    name: 'Resources',
    metaInfo: {
        title: 'Resources',
        meta : [
            {
                name: 'description',
                content : 'Resources'
            },
            {
                name: 'keywords',
                content : 'Resources, retrofitting, cyclone, weather, storm, protection'
            }
        ]
    },

    data: () => ({

    }),
    computed: {

    },
})
